export default __webpack_public_path__ + "static/media/Shopping-Cart.dca34fc2.jpg";